<template>
  <div>
    <scroller :on-refresh="refresh">
      <header>
        <!-- <p class="header-title">明医智讲师端</p> -->

        <div class="side">
          <img :src="live.liveCoverImg" alt class="title-img" />
          <div class="info">
            <div>
              <img src="../../assets/img/lumi.png" alt />
              <span>{{ live.liveName }}</span>
            </div>
            <!-- <div class="current">
            <span v-if="live.liveStatus===1">观看人次：{{current.total}} / 在线人数： {{current.times}}</span>
            <span v-if="live.liveStatus===2">观看人次：{{live.liveAttr.lookNum}}</span>
            </div>-->
            <p class="col-red">
              直播时间：{{ live.liveStartTime }} 至 {{ live.liveEndTime }}
            </p>
          </div>

          <mt-navbar v-model="selected" style="width: 50%">
            <mt-tab-item id="question">提问消息</mt-tab-item>
          </mt-navbar>
        </div>
      </header>
      <main>
        <div class="content">
          <div class="question-list">
            <div
              class="questions-list-item"
              v-for="item in questList"
              :key="item.liveQuestionId"
            >
              <div class="questions-list-item-heading">
                <img
                  :src="
                    item.avatar
                      ? item.avatar
                      : require('../../assets/img/timg.jpg')
                  "
                />
                <span class="questions-list-item-username">{{
                  item.nick
                }}</span>
              </div>
              <div class="questions-list-item-content">
                {{ item.queContent }}
              </div>
            </div>
            <div
              v-if="!questionNone"
              style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
              "
              @click="loadMoreQuestion"
            >
              点击加载更多...
            </div>
            <div
              v-else
              style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
              "
            >
              暂无更多数据...
            </div>
          </div>
        </div>
      </main>
    </scroller>
  </div>
</template>

<script>
let timer = null
import Base64 from 'base-64'
import ReconnectingWebSocket from 'reconnecting-websocket'
export default {
  // beforeRouteLeave(to, form, next) {
  //   if (timer) {
  //     clearInterval(timer)
  //   }
  //   if (this.websock) {
  //     this.websock.close()
  //   }
  //   this.websock = null
  //   next()
  // },
  data() {
    return {
      selected: 'question',
      liveId: '',
      questionList: [],
      questList: [],
      websock: null,
      isAuth: false,
      live: {},
      // 人数
      current: {
        total: 0,
        times: 0,
      },
      // userInfo: {},
      questionIndex: 0,
      questionNone: false,
    }
  },
  created() {
    let _this = this
    _this.liveId = decodeURIComponent(location.href.split('liveId=')[1])
    // _this.getUserInfo()
    // setTimeout(function () {
    //   _this.initWebSocket()
    // })
  },
  mounted() {
    this.getLiveDetail()
    this.getAllQuestions()
    // this.initWebSocket()
  },
  methods: {
    refresh() {
      location.reload()
    },
    getLiveDetail() {
      this.$http({
        url: `/live/live/info/${this.liveId}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.live = data.data
          this.live.liveStartTime = this.live.liveStartTime.substring(0, 19)
          this.live.liveEndTime = this.live.liveEndTime.substring(11, 19)
          if (this.live.liveAttr) {
            this.live.liveAttr = JSON.parse(data.data.liveAttr).lookNum
          }
          // this.initWebSocket()
        }
      })
    },
    //获取历史提问
    getAllQuestions() {
      localStorage.removeItem('questList_' + this.liveId)
      this.$http({
        url: `/live/livequestioninfor/getQuestionsByPage`,
        method: 'get',
        params: {
          liveId: this.liveId,
          index: this.questionIndex,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (!data.data) {
            this.questionNone = true
            return this
          }
          if (data.data.length) {
            localStorage.setItem(
              'questList_' + this.liveId,
              JSON.stringify(data.data)
            )
            this.questList = this.questList.concat(data.data)
          }
        } else {
          this.questionIndex = 0
          this.this.questList = []
        }
      })
    },
    loadMoreQuestion() {
      this.questionIndex = this.questionIndex + 10
      this.getAllQuestions()
    },
    // getUserInfo() {
    //   let openId = sessionStorage.getItem('openId')
    //   console.log(this.liveId)
    //   this.$http({
    //     url: '/live/liveUsers/getUserDetail',
    //     method: 'get',
    //     params: { openId: openId },
    //   }).then(({ data }) => {
    //     if (data && data.code === 0) {
    //       this.userInfo = data.user
    //     }
    //   })
    // },
    // initWebSocket() {
    //   if (timer) {
    //     clearInterval(timer)
    //   }
    //   // 初始化weosocket
    //   let obj = {}
    //   obj.id = '14'
    //   obj.liveId = this.liveId
    //   obj.status = this.live.liveStatus
    //   obj.token = '123457'
    //   const wsuri =
    //     this.$wxBaseURL + '?request=' + Base64.encode(JSON.stringify(obj))
    //   this.websock = new ReconnectingWebSocket(wsuri)
    //   this.websock.onmessage = this.websocketonmessage
    //   this.websock.onopen = this.websocketonopen
    //   this.websock.onerror = this.websocketonerror
    //   this.websock.onclose = this.websocketclose
    // },
    // websocketonopen(e) {
    //   // 连接建立之后执行send方法发送数据
    //   console.log('Connection open ...')
    //   this.openInvake(e)
    // },
    // websocketonerror() {
    //   // 连接建立失败重连
    //   this.initWebSocket()
    // },
    // websocketonmessage(e) {
    //   // 数据接收
    //   console.log('数据接收' + e)
    //   let _this = this
    //   const redata = JSON.parse(e.data)
    //   var data = eval('(' + e.data + ')')
    //   console.log('onmessage data: ' + JSON.stringify(data))
    //   switch (data.uri) {
    //     case (1 << 8) | 220: // ping message
    //     case (2 << 8) | 220: // pong message
    //       console.log('ping message: ' + JSON.stringify(data))
    //       _this.pingInvake(data)
    //       break
    //     case (3 << 8) | 220: // system message
    //       _this.sysInvake(data)
    //       break
    //     case (4 << 8) | 220: // error message
    //       console.log('error message: ' + JSON.stringify(data))
    //       _this.closeInvake(null)
    //       break
    //     case (5 << 8) | 220: // auth message
    //       console.log('auth message: ' + JSON.stringify(data))
    //       break
    //     case (6 << 8) | 220: // broadcast message   //评论消息
    //       window.pageYOffset = 0
    //       document.documentElement.scrollTop = 0
    //       document.body.scrollTop = 0
    //       _this.broadcastInvake(data)
    //       break
    //     case (7 << 8) | 220: // 提问消息
    //       window.pageYOffset = 0
    //       document.documentElement.scrollTop = 0
    //       document.body.scrollTop = 0
    //       _this.broadcastInvake(data)
    //       break
    //     case (8 << 8) | 220: // 评论删除或者提问删除
    //       _this.getAllComments()
    //       _this.getAllQuestions()
    //       break
    //     case (9 << 8) | 220: //直播修改通知
    //       _this.getLiveList()
    //       break
    //   }
    // },
    // websocketclose(e) {
    //   // 关闭
    //   console.log('断开连接', e)
    //   this.closeInvake(e)
    // },
    // send(auth, mess) {
    //   //发送消息的时候触发
    //   if (!window.WebSocket || !this.websock) {
    //     return
    //   }
    //   if (this.websock.readyState == WebSocket.OPEN || auth) {
    //     console.log('send: ' + mess)
    //     this.websock.send(mess)
    //   } else {
    //     console.log('连接没有成功，请重新登录')
    //   }
    // },
    // openInvake(e) {
    //   // let obj = {}
    //   // obj.code = 10000
    //   // obj.nick = '陌'
    //   // obj.userId = '14'
    //   // obj.liveId = this.liveId
    //   // obj.liveStatus = this.live.liveStatus
    //   // this.send(true, JSON.stringify(obj))
    //   timer = setInterval(() => {
    //     this.pingInvake()
    //   }, 40000)
    // },
    // closeInvake(e) {
    //   this.websock = null
    //   this.isAuth = false
    //   console.log('登录失败，网络连接异常')
    //   // timer = setTimeout(() => {
    //   //   this.websocketonerror()
    //   // }, 3000)
    // },
    // sysInvake(data) {
    //   switch (data.extend.code) {
    //     case 20001: // user count
    //       console.log('current user: ' + data.extend.mess)
    //       if (this.live.liveStatus === 2) {
    //         this.tim = data.extend.mess
    //         if (!this.tims) {
    //           this.total =
    //             parseInt(this.tim) + parseInt(this.live.liveAttr.lookNum)
    //         } else {
    //           this.total = parseInt(this.tim) + parseInt(this.tims)
    //         }

    //         console.log(this.total)
    //       } else {
    //         const current = data.extend.mess.split('_')
    //         this.current.total = current[0]
    //         this.current.times = current[1]
    //       }
    //       // const current = data.extend.mess.split('_')
    //       // this.current.total = current[0]
    //       // this.current.times = current[1]
    //       break
    //     case 20002: // auth
    //       console.log('auth result: ' + data.extend.mess)
    //       this.isAuth = data.extend.mess
    //       if (this.isAuth) {
    //         console.log('欢迎来到HF聊天室！')
    //       }
    //       break
    //     case 20003: // system message
    //       console.log('system message: ' + data.extend.mess)
    //       break
    //     case 20004: // system message
    //       this.tims = data.extend.mess
    //       this.total = parseInt(this.tim) + parseInt(this.tims)
    //       break
    //   }
    // },
    // broadcastInvake(data) {
    //   console.log('我是广播消息:')
    //   let obj = JSON.parse(data.body)
    //   if (data.uri === 2012) {
    //     obj.avatar = obj.icon
    //     obj.queContent = obj.content
    //     this.questList.unshift(obj)
    //     localStorage.setItem(
    //       'questList_' + this.liveId,
    //       JSON.stringify(this.questList)
    //     )
    //   }
    // },
    // pingInvake(data) {
    //   //发送pong消息响应
    //   this.send(this.isAuth, "{'code':10016}")
    // },
  },
}
</script>

<style lang='scss' scoped>
main,
body,
p {
  margin: 0;
  padding: 0;
}
.info {
  img {
    width: 40px;
    display: inline-block;
    //     margin-right: 10px;
  }

  padding: 1rem 0;
  background-color: #fff;
  .col-red {
    color: #666;
    font-size: 12px;
  }
  p {
    font-size: $font-title2;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  span {
    margin-right: 10px;
    margin-left: 5px;
    font-size: 18px;
    font-style: oblique;
  }
}
.current {
  text-align: right;
  color: #fff;
  span {
    background-color: $theme-color;
    border-radius: 10px;
    padding: 2px 5px;
    font-size: 12px;
    color: #fff;
    font-style: normal;
  }
}
.header-title {
  background-color: $theme-color;
  font-size: 18px;
  padding: 1rem 0;
  color: #fff;
  font-weight: bold;
  margin-bottom: 0;
  text-align: center;
}
body,
html {
  height: 100%;
}
.content {
  height: 80%;
  margin-top: 4px;
}
.side {
  background-color: #fff;
  box-sizing: border-box;
  padding: 1rem;
}
.question {
  height: 65%;
  border: 1px solid #bfbfbf;
  border-bottom: 0;
  background-color: #fff;
}
.title-img {
  width: 100%;
  height: 200px;
  border-radius: 5px;
}
.question-title {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  border-bottom: 1px solid #bfbfbf;
}
.live {
  // text-align: center;
  padding: 5px 2rem;
}
.question-list {
  width: 100%;
  display: flex;
  flex-flow: column;
  overflow: scroll;
  padding: 0 10px;
}
.questions-list-item {
  width: 100%;
  flex-shrink: 0;
  margin-bottom: 20px;
}
.questions-list-item-heading {
  display: inline-block;
}
.questions-list-item-heading > img {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  vertical-align: middle;
}

.questions-list-item-username {
  margin-left: 5px;
  font-weight: bold;
}

.questions-list-item-content {
  padding-left: 4rem;
}
</style>
